 
    <p-checkbox
      [(ngModel)]="this.field.value"
      binary="true"
    ></p-checkbox>
  